// Generated by purs version 0.13.8
"use strict";
var $foreign = require("./foreign.js");
var Effect_Uncurried = require("../Effect.Uncurried/index.js");
var alert = Effect_Uncurried.runEffectFn3($foreign["_alert"]);
module.exports = {
    alert: alert
};
